/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { useMutation } from 'react-query';

import { ProjectApiService } from '../../services/ProjectApiService';
import { EntityId } from '../../types/api/EntityId';
import { UpdateProjectRequestBody } from '../../types/project/UpdateProjectRequestBody';
import { reactToUpdateProject } from '../../utils/reactions';

export const useUpdateProject = (awaitForReaction: boolean) => {
  return useMutation(
    ({
      organizationId,
      projectId,
      data,
    }: {
      organizationId: EntityId;
      projectId: EntityId;
      data: UpdateProjectRequestBody;
    }) => {
      return ProjectApiService.updateProject({
        projectId,
        organizationId,
        data,
      });
    },
    {
      onSettled: async (data, error, variables) => {
        awaitForReaction ? await reactToUpdateProject({ ...variables }) : void reactToUpdateProject({ ...variables });
      },
      onError: e => {
        throw e;
      },
    },
  );
};
